import { useFormContext } from "react-hook-form";
import { ChangeStageComment } from "../../../types/pipeline";
import { RegisterVisitaForm } from "./RegisterVisitaForm";
import { Dispatch, SetStateAction } from "react";
import { ValidFormCompnentes } from "../EditComponents/AddCommentChangeStage";
import { VisitaRegister } from "../../../types/empresa";

interface Props {
    setCurrentComponent: Dispatch<SetStateAction<ValidFormCompnentes>>
}

export function RegisterVisit({ setCurrentComponent }: Props) {
    const { watch, getValues, setValue } = useFormContext<ChangeStageComment>();

    const fechaInicio = watch("fechaInicio");
    const fechaFin = watch("fechaFin");

    const handleAddVisita = async (data: VisitaRegister) => {
        data.horaInicio = data.horaInicio != undefined 
            ? `${data.horaInicio}:00`
            : data.horaInicio;

        data.horaFin = data.horaFin != undefined 
            ? `${data.horaFin}:00`
            : data.horaFin;

        const visitas = getValues("visitas");
        setValue("visitas", [...visitas, data])
        
        setCurrentComponent("Campañas confirmadas");
    };

    return (
        <RegisterVisitaForm 
            minAvailableDate={fechaInicio}
            maxAvailableDate={fechaFin}
            onAddVisit={handleAddVisita}
            onCancel={() => setCurrentComponent("Campañas confirmadas")}/>
    );
}